import React from 'react';

interface EmptyStateProps {
  hasSearched: boolean;
}

export const EmptyState: React.FC<EmptyStateProps> = ({ hasSearched }) => {
  if (!hasSearched) {
    return (
      <div className="flex flex-col items-center justify-center py-20 text-gray-400">
        <svg className="w-24 h-24 mb-6 opacity-20" fill="none" viewBox="0 0 24 24" stroke="currentColor">
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={1} d="M19 21V5a2 2 0 00-2-2H7a2 2 0 00-2 2v16m14 0h2m-2 0h-5m-9 0H3m2 0h5M9 7h1m-1 4h1m4-4h1m-1 4h1m-5 10v-5a1 1 0 011-1h2a1 1 0 011 1v5m-4 0h4" />
        </svg>
        <h3 className="text-xl font-medium text-gray-600">Pronto para buscar</h3>
        <p className="mt-2 text-center max-w-sm">
          Digite o endereço para consultar o histórico de transações e dados de ITBI.
        </p>
      </div>
    );
  }

  return (
    <div className="flex flex-col items-center justify-center py-20 text-gray-400">
      <div className="bg-gray-50 p-6 rounded-full mb-4">
        <svg className="w-12 h-12 text-gray-400" fill="none" viewBox="0 0 24 24" stroke="currentColor">
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9.172 16.172a4 4 0 015.656 0M9 10h.01M15 10h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z" />
        </svg>
      </div>
      <h3 className="text-xl font-medium text-gray-600">Nenhum resultado encontrado</h3>
      <p className="mt-2 text-center max-w-sm text-sm">
        Não encontramos transações para o termo pesquisado. Tente simplificar o endereço ou buscar pelo nome do bairro.
      </p>
    </div>
  );
};